import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

export default function ProtectedRoute({ children }) {
  const token = localStorage.getItem("token");

  // 🔒 Se não houver token → login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  try {
    // Apenas valida se o token é válido
    jwtDecode(token);
  } catch (err) {
    console.error("Token inválido:", err);
    localStorage.removeItem("token");
    return <Navigate to="/login" replace />;
  }

  // 👍 Autenticado → pode entrar
  return children;
}
